import React from "react";
import clsx from "clsx";
import { options } from '@univdiam/ui/lib/StatusOptions';



interface StatusBadgeProps {
    status: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const match = options.find(opt => opt.id === status);
    if (!match) return null;

    return (
        <div
            className={clsx(
                "inline-flex items-center gap-1 px-2 py-1 rounded-md border caption",
                match.bgColor,
                match.borderColor,
                "text-black"
            )}
        >
            {/* {match.icon} */}
            {match.label}
        </div>
    );
};
